import {FC, useEffect, useState} from 'react'
import Content from "../main/Content";
import Tire from "./Tire";
import {getOptions} from "../../wordpress/operations/get-options";
import Category from "./Category";
import Offers from "../Campaign";
import Volvo from "./Volvo";
import VW from "./VW";
import Mercedes from "./Mercedes";
import ExtraFields from "./ExtraFields";
import NavNextPrev from "../common/NavNextPrev/NavNextPrev";
import {hjulskifteFlows} from "../../constants/global";
import ServiceAgreement from "./ServiceAgreement";

interface Props {
    booking: Booking
    pageContent:ContentPage,
    setBooking: Function,
    content: Content
}

const Options: FC<Props> = ({ pageContent, booking, setBooking, content }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [options, setOptions] = useState<any>(null);
    if(!options) {
        getOptions(booking).then((val) => {
            setOptions(val)
        })
        return
    }

    return (
        <>
            <div className="input-outer reg-container">
                <div className="row mobile-reverse">
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                        <Offers booking={booking} setBooking={setBooking}/>
                    </div>
                    <div className="main-bg col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12 z-1">
                        <Content booking={booking} content={pageContent}/>
                        <div className={"relative z-1"}>
                        {booking.service.step !== 'open' && (
                            <>
                                <ExtraFields booking={booking} setBooking={setBooking}/>
                                <Volvo mechanics={options.options_extra.volvo_pst} booking={booking} setBooking={setBooking}/>
                                <VW option={options.options_extra.vw_connect} booking={booking} setBooking={setBooking}/>
                                <Mercedes option={options.options_extra.mercedes_code} booking={booking} setBooking={setBooking}/>
                                <ServiceAgreement option={options.options_extra.serviceavtal} booking={booking} setBooking={setBooking}/>
                            </>
                        )}
                        {hjulskifteFlows.includes(booking.service.booking_flow) && (
                            <Tire booking={booking} setBooking={setBooking}/>
                        )}
                        </div>
                        {options.categories.map((category: any, i: number) => (
                            <Category key={i} booking={booking} setBooking={setBooking} category={category}/>
                        ))}
                        <div>
                            <NavNextPrev booking={booking} setBooking={setBooking} content={content}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default Options
